import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';

import config from 'config';
import { IconWithDotBadge } from 'shared/components';
import { getUserInitials } from 'modules/user/utils/user';

import theme from './AppointmentParticipantsInfo.scss';

const isClalit = config.product_name === 'clalit';

const propTypes = {
  subjectName: PropTypes.string,
  policyId: PropTypes.string,
  gender: PropTypes.string,
  isMasked: PropTypes.bool,
  description: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  avatar: PropTypes.string,
};

const defaultProps = {
  subjectName: '',
  policyId: undefined,
  gender: 'unknown',
  isMasked: false,
  description: null,
  firstName: null,
  lastName: null,
  avatar: null,
};

const SubjectCard = ({
  subjectName,
  policyId,
  gender,
  isMasked,
  description,
  avatar,
  firstName,
  lastName,
}) => {
  if (isMasked) {
    return (
      <div className={ classnames(theme.itemContainer, { [theme.clalitItemContainer]: isClalit }) }>
        <div className={ theme.iconContainer }>
          <IconWithDotBadge name="male-avatar" />
        </div>

        <div className={ theme.titleContainer }>
          <Choose>
            <When condition={ isClalit }>
              <div className={ theme.name }>
                <FormattedMessage id="Appointments.PatientAppointmentCard.ConsultationFor.Title" defaultMessage="** Consultation For" />
              </div>
            </When>
            <Otherwise>
              <div className={ theme.title }>
                <FormattedMessage id="Appointments.AppointmentCard.Patient.Title" defaultMessage="** Patient" />
              </div>
            </Otherwise>
          </Choose>
          <div className={ classnames(theme.name) }>*****</div>
        </div>
      </div>
    );
  }

  return (
    <div className={ classnames(theme.itemContainer, { [theme.clalitItemContainer]: isClalit }) }>
      <div className={ theme.iconContainer }>
        <IconWithDotBadge
          userInfo={{ avatar, initials: getUserInitials({ firstName, lastName }) }}
        />
      </div>

      <div className={ theme.titleContainer }>
        <Choose>
          <When condition={ isClalit }>
            <div className={ classnames(theme.name, { [theme.clalitName]: isClalit }) }>
              <FormattedMessage id="Appointments.PatientAppointmentCard.ConsultationFor.Title" defaultMessage="** Consultation For" />
            </div>
          </When>
          <Otherwise>
            <div className={ theme.title }>
              <FormattedMessage id="Appointments.AppointmentCard.Patient.Title" defaultMessage="** Patient" />
            </div>
          </Otherwise>
        </Choose>

        <div className={ classnames({ [theme.name]: !isClalit, [theme.blackMediumColor]: isClalit }) } style={ isClalit ? { fontSize: 16, lineHeight: '22px' } : {} }>
          { subjectName || <FormattedMessage id="General.Anonymous" defaultMessage="** Anonymous" /> }
        </div>
      </div>
    </div>
  );
};

SubjectCard.propTypes = propTypes;
SubjectCard.defaultProps = defaultProps;

export default SubjectCard;
